import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ProjectGroupResponse } from 'cargo-chief-commons';

@Component({
	selector: 'app-select-project-group',
	templateUrl: './select-project-group.component.html',
	styleUrls: ['./select-project-group.component.scss'],
})
export class SelectProjectGroupComponent implements OnInit {
	projectGroupList: ProjectGroupResponse[] = null;
	selectedGroupId = null;

	constructor(
		public dialogRef: MatDialogRef<SelectProjectGroupComponent>,
		@Inject(MAT_DIALOG_DATA)
		public dialogData: { projectGroupList: ProjectGroupResponse[] }
	) {}

	ngOnInit(): void {
		this.projectGroupList = this.dialogData.projectGroupList;
	}

	closeDialog(data: any) {
		this.dialogRef.close(data);
	}

	groupSelected() {
		this.dialogRef.close({ projectGroupId: this.selectedGroupId });
	}
}
